import React from "react";
import { Button, Menu } from "antd";
import { Link } from "react-router-dom";
import myworkapp_logo from "../../../assets/svg/myworkapp_logo.svg";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  HomeOutlined,
  DashboardOutlined,
  FileTextOutlined,
  ShoppingCartOutlined,
  BoxPlotOutlined,
  ContactsOutlined,
  AppstoreOutlined,
  ClockCircleOutlined,
  SearchOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { useCurrentUser } from "../../../api/hooks/auth";

const Sidebar = ({ collapsed, setCollapsed }) => {
  const { data: userData } = useCurrentUser();

  const items = [
    {
      key: "home",
      label: "Home",
      type: "group",
      children: [
        {
          key: "dashboard",
          icon: <DashboardOutlined />,
          label: (
            <Link
              className="text-current no-underline hover:text-current"
              to="dashboard"
            >
              Dashboard
            </Link>
          ),
        },
        // {
        //   key: "reports",
        //   label: "Reports",
        // },
        // {
        //   key: "analytics",
        //   label: "Analytics",
        // },
        // {
        //   key: "releases",
        //   label: "Releases",
        // },
      ],
    },
    {
      type: "divider",
    },
    {
      key: "processes",
      label: "Processes",
      type: "group",
      children: [
        {
          key: "order",
          icon: <ShoppingCartOutlined />,
          label: (
            <Link
              className="text-current no-underline hover:text-current"
              to="processes/order"
            >
              Orders
            </Link>
          ),
        },
        {
          key: "shipments",
          icon: <FileTextOutlined />,
          label: (
            <Link
              className="text-current no-underline hover:text-current"
              to="processes/shipments"
            >
              Shipments
            </Link>
          ),
        },
        {
          key: "inventory",
          icon: <BoxPlotOutlined />,
          label: (
            <Link
              className="text-current no-underline hover:text-current"
              to="processes/inventory"
            >
              Inventory
            </Link>
          ),
        },
      ],
    },
    {
      type: "divider",
    },
    {
      key: "search",
      icon: <SearchOutlined />,
      label: (
        <Link
          className="text-current no-underline hover:text-current"
          to="search"
        >
          Search
        </Link>
      ),
    },
    {
      type: "divider",
    },
    {
      key: "setup",
      label: "Setup",
      type: "group",
      children: [
        {
          key: "contacts",
          icon: <ContactsOutlined />,
          label: (
            <Link
              className="text-current no-underline hover:text-current"
              to="setup/contacts"
            >
              Contacts
            </Link>
          ),
        },
        {
          key: "products",
          icon: <AppstoreOutlined />,
          label: (
            <Link
              className="text-current no-underline hover:text-current"
              to="setup/products"
            >
              Products
            </Link>
          ),
        },
        {
          key: "activities",
          icon: <ClockCircleOutlined />,
          label: (
            <Link
              className="text-current no-underline hover:text-current"
              to="/activities"
            >
              Activities
            </Link>
          ),
        },
        ...(["admin"].some((p) => userData?.type?.permissions?.[p])
          ? [
              {
                key: "settings",
                icon: <SettingOutlined />,
                label: (
                  <Link
                    className="text-current no-underline hover:text-current"
                    to="/settings"
                  >
                    Settings
                  </Link>
                ),
              },
            ]
          : []),
        // {
        //   key: "devices",
        //   label: (
        //     <Link
        //       className="text-current no-underline hover:text-current"
        //       to="setup/devices"
        //     >
        //       Devices
        //     </Link>
        //   ),
        // },
        // {
        //   key: "tags",
        //   label: (
        //     <Link
        //       className="text-current no-underline hover:text-current"
        //       to="setup/tags"
        //     >
        //       Tags
        //     </Link>
        //   ),
        // },
        // {
        //   key: "Connectors",
        //   label: "Connectors",
        // },
      ],
    },
    // {
    //   type: "divider",
    // },
  ];

  function getMenuItemsBasedOnRole(role) {
    console.log("Role: " + role);
    switch (role) {
      case "CUSTOMER":
      case "PROCESSOR":
        return [
          {
            key: "processes",
            label: "Processes",
            type: "group",
            children: [
              {
                key: "order",
                icon: <ShoppingCartOutlined />,
                label: (
                  <Link
                    className="text-current no-underline hover:text-current"
                    to="processes/order"
                  >
                    Orders
                  </Link>
                ),
              },
              // {
              //   key: "shipments",
              //   icon: <FileTextOutlined />,
              //   label: (
              //     <Link
              //       className="text-current no-underline hover:text-current"
              //       to="processes/shipments"
              //     >
              //       Shipments
              //     </Link>
              //   ),
              // },
            ],
          },
        ];
      default:
        return items;
    }
  }

  const onClick = (e) => {
    // console.log("click ", e);
  };

  return (
    <div
      className={`sticky top-0 flex h-full flex-col justify-between overflow-auto border-r bg-[#667DBE]`}
    >
      <div>
        <div className="flex justify-end">
          <Button
            type="text"
            className="text-white"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: "16px",
              width: 64,
              height: 64,
            }}
          />
        </div>
        <Menu
          onClick={onClick}
          // defaultSelectedKeys={items?.[0]?.key}
          mode="inline"
          items={getMenuItemsBasedOnRole(userData?.type?.name)}
          className="!border-e-0"
          inlineCollapsed={collapsed}
        />
      </div>
      {/* <div className="pb-4 pl-4">
        <img src={myworkapp_logo} alt="MyWorkApp" />
      </div> */}
    </div>
  );
};

export default Sidebar;
